import type { Dispatch, SetStateAction } from 'react';
import Modal from '../04_ modal/Modal';
import Variables from '../../style/variables.scss';
import Constants from '../../utils/Constants';

const ReservationModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: Dispatch<SetStateAction<boolean>>;
}) => {
  const closeModal = () => {
    onClose(false);
  };

  return (
    <Modal
      id='reservation_modal'
      isOpen={isOpen}
      onClose={onClose}
      primaryColor={Variables.primaryColor}
      secondaryColor={Variables.secondaryColor}
    >
      <div className='reservation_modal'>
        <div className='reservation_modal_content'>
          <h2>Reserve now</h2>
          <div className='reservation_modal_buttons'>
            <a
              href={Constants.bookNowLink}
              target='_blank'
              rel='noreferrer'
              className='opacity_transition_low'
              onClick={closeModal}
            >
              <div>RESERVE YOUR SIGNATURE STAY</div>
            </a>
            <p className='reservation_modal_michelin'>
              MICHELIN-recommended hotel
            </p>
            <p className='reservation_modal_closed'>
              Due to the weather, Rooftop Bar is closed until April 2027.
            </p>
            <a
              href={Constants.rooftopBarBookingLink}
              target='_blank'
              rel='noreferrer'
              className='opacity_transition_low reservation_modal_buttons_rooftop'
              onClick={closeModal}
            >
              <div>RESERVE SPLIT ROOFTOP BAR EXPERIENCE</div>
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReservationModal;
